<template>
  <div class="dynamic-area">
    <input ref="tArea"
      :style="inputCustomStyle"
      :class="['dynamic-area__text-area', noAnim ? 'dynamic-area__text-area--noanim' : '']" 
      v-model="actValue"
      @blur="emitChange"
      :placeholder="placeholder"
      v-on:keyup.enter="emitChange"
      :readonly="readonly"
      :spellcheck="spellcheck"
      :maxlength="maxlength"
      />
    <div ref="tHidden" class="dynamic-area__hidden">{{actValue}}</div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      actValue: null,
      prevValue: null
    }
  },
  props: {
    value: String,
    minWidth: Number,
    inputCustomStyle: Object,
    placeholder: String,
    readonly: Boolean,
    spellcheck: Boolean,
    maxlength: Number,
    noAnim: Boolean
  },
  watch: {
    actValue: function() {
      this.resize()
    },
    value: function () {
      this.actValue = this.value
      this.prevValue = JSON.parse(JSON.stringify(this.actValue))
    }
  },
  mounted () {
    this.actValue = this.value
    this.prevValue = JSON.parse(JSON.stringify(this.actValue))
  },
  methods: {
    resize () {
      setTimeout(() => {
        let width = this.$refs.tHidden.clientWidth
        if(width>this.minWidth) {
          this.$refs.tArea.style.width = width+10+'px'
        } else {
          this.$refs.tArea.style.width = this.minWidth+10+'px'
        }
      }, 0)
    },
    emitChange () {
      this.$emit('blur')
      if(this.actValue === this.prevValue) {
        return
      }
      if(!this.actValue.length) {
        this.actValue = this.prevValue
        return
      }
      this.prevValue = this.actValue
      this.$emit('changed', this.actValue)
    },

  }
}
</script>

<style lang="scss">
.dynamic-area {
  &__text-area {
    resize: none;
    overflow: hidden;
    font-family: inherit;
    font-size: inherit;
    text-align: center;
    transition: width 0.2s ease;
    border: solid 0px;
    background: transparent;

    cursor: pointer;
  }

  &__text-area--noanim {
    transition: none;
  }

  &__text-area {
    color: inherit;
    outline-width: 0;
  }
  &__hidden {
    visibility: hidden;
    position: absolute;
    z-index: -9999px;
  }
}
</style>